import * as React from "react";
import { useState, useEffect, useRef } from 'react';
import Icon from '../../../icons';
import {WorkkardDetailPopupLoader} from '../../../components/SkeletonLoader';
import { useSelector } from 'react-redux';
import  { RightPanelConstant, RenderEngineKey, DATE_FORMAT} from '../constants';
import { isMobile } from "../../../common/util";
import moment from 'moment';
import { useModules } from "../../../utils/modules";

function WorkkardDetailForPopUpComponent(props) {
    const { isModuleEnabled } = useModules();
    const workkardData = useSelector(state => state.workkardDetail.workkardDetail);

    const [workkardDetail, setWorkkardDetail] = useState('');
    const [canRearrange, setCanRearrange] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [shouldUpdate, setShouldUpdate] = useState(false);

    useEffect(() => {
        if(workkardData){
            setWorkkardDetail(workkardData);
        }
    }, []);

    const isFirstRender = useRef(true);
    useEffect(() => {
        if(isFirstRender.current){
            isFirstRender.current = false;
            return;
        }
        setWorkkardDetail(workkardData);
        setIsLoading(false);
        setShouldUpdate(false);
        props.togglecfloader();
    }, [workkardData]);

    function toggleSaveData(){
        if(!shouldUpdate){
            setShouldUpdate(true);
        }        
    }

    const saveRearrangedOrder = () => {
        if(shouldUpdate) {
            setCanRearrange(false)
            setIsLoading(false)
            props.saveUserCFSettings()
        }
    }

    return (
            <React.Fragment>
                <div className="modalHeader bgGray">
                <div className="colFlex">
                        <div className="alignMiddle">
                            <h2 className="rowFlex flexGrow">{RightPanelConstant.WorkkardDetailText}</h2>
                            <div className="alignRight alignMiddle">
                                {process.env.foo_canrearrangecf == "true" && isModuleEnabled("workkards.workkard_fields_rearrangement") && !isMobile() && !canRearrange && <label className="reArrangeInfo"><a className="pointer" onClick={() => setCanRearrange(true)}>Rearrange</a><span className="quickTooltip-bottom mr" data-quicktooltip="This option allows the user to rearrange the Workkard fields."><Icon name="info" className="icon ml greyInfoIcon" /></span></label>}
                                <a href="javascript:void(0)" onClick={props.closeDialogBox}><span className="iconRipple"><Icon name="close" className="icon" /></span></a>
                            </div>
                        </div>

                        <div className="workkardMainInfo mt">
                            {props.workkardDetailInfo(workkardDetail, true, true)}
                            <div className="colFlex propertyLocation wth-3">
                               <ul className="rowFlex wrapFlex">
                                {
                                    props.renderCustomFields({
                                        includeFields:[RenderEngineKey.PropertyLocation]
                                    },false,true)
                                }
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <>
                    {isLoading ?
                        <WorkkardDetailPopupLoader count={8} />
                        : <div className="modalBody">
                            {canRearrange && 
                                <div className="infoBoxMsg arrangeBox">
                                    <Icon name="info" className="icon mr" /> You can now arrange the fields based on your specific needs.
                                </div>
                            }
                            <div className="wkDetailInfo InlineEditBlock wth-12">
                                <ul className="rowFlex wrapFlex">
                                    {
                                        props.renderCustomFields({
                                            excludeFields: props.getExcludeFields(),
                                            showLabel: true,
                                            workkardDetail: workkardDetail,
                                            shouldupdate: toggleSaveData
                                        },false,true, canRearrange)
                                    }
                                </ul>
                                {
                                    (workkardDetail.CreatedDateString != null || workkardDetail.CreatedDateString != "" || workkardDetail.CreatedDate) &&
                                    <div className="wkDetailInfo InlineEditBlock wth-3">
                                        <label>Created Date</label>
                                        { moment.unix(workkardDetail.CreatedDate).utc().format(DATE_FORMAT) }
                                    </div>
                                }
                            </div>
                            <div className="wkDescription">
                                <label className="mb__8 mt">Description</label>
                                <p dangerouslySetInnerHTML={{__html :workkardDetail.WorkkardSummaryFull!="" ? workkardDetail.WorkkardSummaryFull : "-" }}></p>
                            </div>
                        </div>
                    }
                </>               
                { canRearrange && 
                    <div className="modalFooter resetDefault">
                        <label className="alignMiddle uploadButton"><a className="pointer" onClick={() => { setCanRearrange(false); setIsLoading(true); props.resetUserCFSettings(); }}>Reset to default</a><span className="quickTooltip-top" data-quicktooltip="Choosing this option will reset the field sequencing to the organization's default order."><Icon name="info" className="icon ml greyInfoIcon" /></span></label>
                        <div className="rowFlex alignRight alignMiddle">                            
                            <button className={`btn buttonGradient ${!shouldUpdate ? 'disabled':''}`} onClick={saveRearrangedOrder}>
                                <span>Save</span>
                            </button>                            
                            <button className="btn link" type="button" onClick={() => { setCanRearrange(false); setShouldUpdate(false); }}>Cancel</button>
                        </div>
                    </div>
                }
            </React.Fragment>
    )
}

export default WorkkardDetailForPopUpComponent;
